import React, { Component } from "react";

export default class Activate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
    };
  }

  setActive() {
    this.setState({ active: true });
  }

  setInactive() {
    this.setState({ active: false });
  }

  render() {
    const { className = "", activeClassName = "", children } = this.props;
    const { active } = this.state;
    return (
      <div className={`${active ? activeClassName : ""} ${className}`}>
        {children}
      </div>
    );
  }
}
